import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ComingSoon from './Pages/ComingSoon';
import PrivacyPolicy from './Pages/PrivacyPolicy'; // Import your PrivacyPolicy component
import Navbar from './Components/Navbar';
import Footer from './Components/Footer';
import ContactUs from './Pages/ContactUs';
import DiscountModal from './Components/DiscountModal';
import AboutUs from './Pages/AboutUs';
import Home from './Pages/Home';
import Marketing from './Pages/Marketing';
import ScrollToTop from './Components/ScrollToTop';
import AdminPanel from './Pages/AdminPanel';
import TeacherPanel from './Pages/TeacherPanel';
import StudentPanel from './Pages/StudentPanel';
import Library from './Pages/Library';
import DemoRequestsPage from './Pages/DemoRequestPage';
import WhatsapWiget from './Components/WhatsapWidget';
import Career from './Pages/Career';
import TermsAndConditions from './Pages/TermsAndConditions';
import CareerApplicationTable from './Pages/CareerApplicationTable';
import ContactList from './Pages/ContactList';
import ScrollToTopButton from './Components/ScrollToTopButton';
import Blog from './Pages/Blogs';
import MobileAppPanel from './Pages/MobileAppPanel';
import BlogSingle from './Pages/BlogSingle';
import Sitemap from './Pages/sitemap';
import SchoolERP from './Pages/SchoolERP.jsx';
import Haryana from './Pages/haryana';
import Rajasthan from './Pages/rajasthan';
import Punjab from './Pages/punjab';
import UttarPradesh from './Pages/uttar-pradesh';
import Sirsa from './Pages/sirsa';
import Lucknow from './Pages/lucknow';
import Prayagraj from './Pages/prayagraj.jsx';
import Amritsar from './Pages/amritsar.jsx';
import Ludhiana from './Pages/ludhiana.jsx';
import Jaipur from './Pages/jaipur.jsx';
import Gurugram from './Pages/gurugram.jsx';
import Faridabad from './Pages/faridabad.jsx';
import Hisar from './Pages/hisar.jsx';
import Kanpur from './Pages/kanpur.jsx';
import Bathinda from './Pages/bathinda.jsx';
import Rohtak from './Pages/rohtak.jsx';
import Bikaner from './Pages/Bikaner.jsx';
import NoidaUP from './Pages/noida.jsx';
import Delhi from './Pages/delhi.jsx';
import SchoolERPPage from './Pages/SchoolERPPage.jsx';
import SchoolERPIndia from './Pages/toperpsoft.jsx'
import Attendance from './Pages/attendance.jsx';
import BengaluruSchoolManagement from './Pages/Bengaluru.jsx';


function Layout() {
  return (
    <Router>
      <ScrollToTop />
      <WhatsapWiget />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/career" element={<Career />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/terms-conditions" element={<TermsAndConditions />} />
        <Route path="/marketing-partner" element={<Marketing />} />
        <Route path="/coming-soon" element={<ComingSoon />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/contact-list-satya-techno" element={<ContactList />} />
        <Route path="/demo-request-satya-techno" element={<DemoRequestsPage />} />
        <Route path="/career-application-satya-techno" element={<CareerApplicationTable />} />
       <Route path="/admin-panel" element={<AdminPanel />} />
        <Route path="/teacher-panel" element={<TeacherPanel />} />
        <Route path="/student-panel" element={<StudentPanel />} />
        <Route path="/library-panel" element={<Library />} />
        <Route path="/blogs" element={<Blog />} />
        <Route path="/blogs/:slug" element={<BlogSingle />} />
        <Route path="/sitemap" element={<Sitemap />} />
        
        <Route path="/SchoolERP" element={<SchoolERP />} />
        <Route path="/SchoolERP/haryana" element={<Haryana />} />
        <Route path="/SchoolERP/rajasthan" element={<Rajasthan />} />
        <Route path="/SchoolERP/punjab" element={<Punjab />} />
        <Route path="/SchoolERP/uttar-pradesh" element={<UttarPradesh />} />
        <Route path="/SchoolERP" element={<SchoolERPPage city="India" />} />

<Route path="/SchoolERP/haryana/sirsa" element={<SchoolERPPage city="Sirsa" />} />
<Route path="/SchoolERP/uttar-pradesh/lucknow" element={<SchoolERPPage city="Lucknow" />} />
<Route path="/SchoolERP/uttar-pradesh/prayagraj" element={<SchoolERPPage city="Prayagraj" />} />

<Route path="/SchoolERP/punjab/amritsar" element={<SchoolERPPage city="Amritsar" />} />
<Route path="/SchoolERP/punjab/ludhiana" element={<SchoolERPPage city="Ludhiana" />} />
<Route path="/SchoolERP/punjab/bathinda" element={<SchoolERPPage city="Bathinda" />} />

<Route path="/SchoolERP/rajasthan/jaipur" element={<SchoolERPPage city="Jaipur" />} />

<Route path="/SchoolERP/haryana/gurugram" element={<SchoolERPPage city="Gurugram" />} />
<Route path="/SchoolERP/haryana/faridabad" element={<SchoolERPPage city="Faridabad" />} />
<Route path="/SchoolERP/haryana/hisar" element={<SchoolERPPage city="Hisar" />} />
<Route path="/SchoolERP/haryana/rohtak" element={<SchoolERPPage city="Rohtak" />} />

<Route path="/SchoolERP/uttar-pradesh/kanpur" element={<SchoolERPPage city="Kanpur" />} />
        
        <Route path="/SchoolERP/rajasthan/bikaner" element={<SchoolERPPage city="Bikaner" />} />
        
        
        <Route path='/erp-mobile-app' element={<MobileAppPanel/>}/>
    
        <Route path="/SchoolERP/delhi" element={<SchoolERPPage city="Delhi" />} />
        <Route path="/SchoolERP/uttar-pradesh/noida" element={<SchoolERPPage city="Noida" />} />
        <Route path="/SchoolERP/prayagraj" element={<SchoolERPPage city="Prayagraj" />} />
        <Route path="/top-school-erp-software-india" element={<SchoolERPIndia />} />  
        <Route path="/best-attendance-erp-software-india" element={<Attendance />} />  
        <Route path='/SchoolERP/Bengaluru' element={<BengaluruSchoolManagement />} />
      </Routes>
      <ScrollToTopButton />
      <DiscountModal />
      <Footer />
    </Router>
  );
}

export default Layout;
